import type { RegionalFormatContextValue } from "@/lib/regional-format/context";

/**
 * A weight total for display in the tenant's number format: one decimal by
 * default, up to four when the total needs them — so 99.9999 is never shown
 * as 100.0.
 */
export function formatWeightTotal(
  total: number,
  formatNumber: RegionalFormatContextValue["formatNumber"],
): string {
  return formatNumber(total, { minimumFractionDigits: 1, maximumFractionDigits: 4 });
}
